var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningAmber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 21L12 2L23 21H1ZM19.53 19L12 5.99L4.47 19H19.53ZM11 16V18H13V16H11ZM11 10H13V14H11V10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAmber);
export default __webpack_public_path__ + "static/media/warning_amber.28674d0aeb14c97e98b371039f36a12c.svg";
export { ForwardRef as ReactComponent };